import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconQrCode: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="qr-code, barcode, scan"><path d="M13.75 13.75V16.25H16.25M17.75 13.75H20.25M20.25 17.75H17.75V20.25M13.75 19.75V20.25M3.75 3.75H10.25V10.25H3.75V3.75ZM13.75 3.75H20.25V10.25H13.75V3.75ZM3.75 13.75H10.25V20.25H3.75V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconQrCode;
